import { useEffect } from 'react';

const useHideCometChat = () => {
  useEffect(() => {
    const displays = new Map<HTMLElement, string>();
    const widgetObservers = new Map<HTMLElement, MutationObserver>();
    const hideWidget = (widget: HTMLElement) => {
      const target = widget;
      if (!displays.has(target)) displays.set(target, target.style.display);
      if (!widgetObservers.has(target)) {
        const observer = new MutationObserver(() => hideWidget(target));
        observer.observe(target, {
          attributeFilter: ['style'],
          attributes: true,
        });
        widgetObservers.set(target, observer);
      }
      if (target.style.display !== 'none') target.style.display = 'none';
    };

    const hideWidgetsWithin = (node: Node) => {
      if (!(node instanceof HTMLElement)) return;
      if (node.matches('#cometchat__widget')) hideWidget(node);
      for (const widget of node.querySelectorAll<HTMLElement>(
        '#cometchat__widget',
      )) {
        hideWidget(widget);
      }
    };
    const bodyObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) hideWidgetsWithin(node);
      }
    });
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    hideWidgetsWithin(document.body);

    return () => {
      bodyObserver.disconnect();
      for (const observer of widgetObservers.values()) observer.disconnect();
      for (const [widget, display] of displays) {
        if (widget.isConnected) widget.style.display = display;
      }
    };
  }, []);
};

export default useHideCometChat;
